import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Typography,
  FormGroup,
  FormControlLabel,
  Switch,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useColorSelect } from "colorMode";

import SettingsDetail from "components/settingsDetail";

import { fetchSettings, logoutUser } from "actions";

const Settings = (props) => {
  const { toggleColorMode, mode } = useColorSelect();
  const dispatch = useDispatch();
  const signedInAs = useSelector((state) => state.authUser.user.email);
  React.useEffect(() => {
    const unsubscribe = dispatch(fetchSettings());
    return unsubscribe;
  }, [dispatch]);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
          marginBottom: (theme) => theme.spacing(1),
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {signedInAs ? `Signed in as ${signedInAs}` : ""}
        </Typography>
        <Button
          size="small"
          variant="outlined"
          startIcon={<LogoutIcon />}
          onClick={() => dispatch(logoutUser())}
        >
          Sign Out
        </Button>
      </Box>
      <FormGroup>
        <FormControlLabel
          control={
            <Switch checked={mode === "dark"} onChange={toggleColorMode} />
          }
          label="Dark Mode"
        />
      </FormGroup>
      <Accordion>
        <AccordionSummary>Connections</AccordionSummary>
        <AccordionDetails
          sx={{ backgroundColor: (theme) => theme.palette.background.paper }}
        >
          <SettingsDetail type="connections" />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>Materials</AccordionSummary>
        <AccordionDetails
          sx={{ backgroundColor: (theme) => theme.palette.background.paper }}
        >
          <SettingsDetail type="materials" />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>Bodies</AccordionSummary>
        <AccordionDetails
          sx={{ backgroundColor: (theme) => theme.palette.background.paper }}
        >
          <SettingsDetail type="bodies" />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>Ports</AccordionSummary>
        <AccordionDetails
          sx={{ backgroundColor: (theme) => theme.palette.background.paper }}
        >
          <SettingsDetail type="ports" />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>Units of Measure</AccordionSummary>
        <AccordionDetails
          sx={{ backgroundColor: (theme) => theme.palette.background.paper }}
        >
          <SettingsDetail type="um" />
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default Settings;
